import { useEffect, useState } from 'react';

export const useVisualViewportHeight = () => {
  const [viewportHeight, setViewportHeight] = useState<number | undefined>();
  useEffect(() => {
    function handleResize() {
      if (window.visualViewport?.scale && window.visualViewport.scale === 1) {
        setViewportHeight(
          window.visualViewport?.height +
            Math.floor(window.visualViewport.offsetTop)
        );
      }
    }
    window.visualViewport?.addEventListener('resize', handleResize);
    return () =>
      window.visualViewport?.removeEventListener('resize', handleResize);
  }, []);
  return viewportHeight;
};
